import { Routes } from '@/routes';

export default {
	'authenticator.index': () => import('@/modules/authenticators/index'),
} as Routes;
